"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterFilled = exports.DeliverType = void 0;
var DeliverType;
(function (DeliverType) {
    DeliverType["EMAIL"] = "email";
})(DeliverType || (exports.DeliverType = DeliverType = {}));
class ParameterFilled {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
exports.ParameterFilled = ParameterFilled;
//# sourceMappingURL=report.js.map